import './opinions.css';
import anja from '../../assets/anja_kramer.jpg';
import sandra from '../../assets/sandra_franck.jpg';
import ronald from '../../assets/ronald_bankowsky.jpeg';


const Opinions = () => {

    const opinions = [
        {   name: 'Anja Kramer',
            position: ' ',  
            positionAdicional: 'Vorstand Bildungswerk ver.di', 
            image: anja,
            quote: 'Als Vorstand des Bildungswerks ver.di begrüße und unterstütze ich ausdrücklich die Entwicklung des Mental-Media-Score. Kinder und Jugendliche sind in ihrem Aufwachsen heute vielfältigen medialen Einflüssen ausgesetzt - oft ohne ausreichenden Schutz vor Inhalten, die ihre psychische Gesundheit belasten können. Ein Instrument wie der Mental-Media-Score, das mediale Angebote transparent bewertet und in einem Ampelsystem verständlich einordnet, kann Eltern, Fachkräften und den jungen Menschen selbst eine wichtige Orientierung bieten. Es ist ein Beitrag dazu, Medienkompetenz zu stärken und Verantwortung zu übernehmen - für den Schutz der seelischen Gesundheit und für faire, altersgerechte Medienangebote.'
        },
        {   name: 'Sandra Franck',
            position: 'Agentur für strategisch kreatives Brandmarketing', 
            positionAdicional: 'Inhaberin 5HEADz',  
            image: sandra,
            quote: 'Als Eva mir vom Mental-Media-Score erzählt hat, habe ich sofort gesagt, dass ich sie dabei unterstütze. Als Grafikdesignerin und Dozentin für Themen rund um generative KI, möchte ich Lust auf eine Zukunft mit digitalen Medien machen. Das bedeutet, dass wir in dem Bereich Kompetenz und Bewusstsein in allen Generationen aufbauen müssen. Am Score gefällt mir der positive Blick auf die digitalen Medien und die Chance, das Gute sichtbar zu machen, um mental ausgewogener zu konsumieren. Darum steht “grün” im Logo des Mental-Media-Scores an erster Stelle.'
        },
        {   name: 'Ronald Bankowsky',
            position: 'Gründer & Wegbereiter für neue Mobilität', 
            positionAdicional: 'fast2work GmbH',  
            image: ronald,
            quote: 'Vom ersten Gespräch an war mir klar: Der Mental-Media-Score trifft einen Nerv. So wie ich die Wirkung von Mobilität sichtbar mache, macht Eva die Wirkung von Worten spürbar. Wandel beginnt da, wo wir bewusst hinsehen - am besten mit einem Tool, das den inneren Kompass kalibriert..'
        },
    ]


  return (
    <div className='opinions'>
        <div className="opinionsContainer">
            <div className="opinionsContent">
            <h4>Stimmen aus der Öffentlichkeit zum Mental-Media-Score</h4>
            <ul className="opinionsCards">
                {opinions.map((item,index) => (<li className="listCard" key={index}>
                    <div className="cardUpper">
                        <img src={item.image} alt="" />
                        <div>
                            <h6>{item.name}</h6>
                            <p>{item.positionAdicional}</p>
                            <p>{item.position}</p>
                        </div>
                        
                    </div>
                    <div className="quoteText">
                        <blockquote data-set={index} className="opinionCard" >
                        {opinions[index].quote}
                        
                        </blockquote> 
                    </div>
                       
                </li>))}               
                
            </ul>
            </div> 
        </div>
    
    </div>
  )
}

export default Opinions